// Lightweight analytics helper — sends events to GA4 (gtag.js in index.html)
// and PostHog (initialized in main.tsx). Safe in browser and Capacitor WebView.

import posthog from "posthog-js";

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

export type AnalyticsParams = Record<string, string | number | boolean | undefined | null>;

export function trackEvent(eventName: string, params: AnalyticsParams = {}): void {
  // Strip null/undefined so providers don't log empty params.
  const cleaned: Record<string, string | number | boolean> = {};
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== null) cleaned[k] = v;
  }

  // GA4
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", eventName, cleaned);
    }
  } catch (err) {
    console.warn("[analytics] GA4 trackEvent failed:", err);
  }

  // PostHog
  try {
    if (typeof window !== "undefined" && (posthog as any).__loaded) {
      posthog.capture(eventName, cleaned);
    }
  } catch (err) {
    console.warn("[analytics] PostHog capture failed:", err);
  }
}

export function identifyUser(userId: string, traits: AnalyticsParams = {}): void {
  try {
    if ((posthog as any).__loaded) {
      const cleaned: Record<string, string | number | boolean> = {};
      for (const [k, v] of Object.entries(traits)) {
        if (v !== undefined && v !== null) cleaned[k] = v;
      }
      posthog.identify(userId, cleaned);
    }
  } catch (err) {
    console.warn("[analytics] PostHog identify failed:", err);
  }
}

export function resetAnalyticsUser(): void {
  try {
    if ((posthog as any).__loaded) posthog.reset();
  } catch (err) {
    console.warn("[analytics] PostHog reset failed:", err);
  }
}
